// extracted by mini-css-extract-plugin
module.exports = {"multiLanguageField__header":"MultiLanguageField_multiLanguageField__header__1Lbdb"};